import axios from 'axios'
import store from '../plugins/store.js'
import Vue from "vue";
import router from "../router";
Vue.use(router);

const instance = axios.create({
    baseURL: 'https://api.mwidirect.com/api',
    //timeout: 1000,
   // baseURL: 'https://localhost:44304/api',
    //Test
    headers: {
        'X-Frame-Options': 'ALLOWALL',
        'Content-Type': 'application/json',
        "Access-Control-Allow-Origin": "*",
        'Accept': '*/*',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS'
    }
});

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

if (store.getters.user) {
        instance.interceptors.request.use(
            config => {
                config.headers['Authorization'] = 'Bearer ' + store.getters.user.token;
                return config;
            }
    );

    instance.interceptors.response.use(response => { return response},
        error => {
            if (error.response.status === 401) {
                router.push('/Login')
            }
            return error;
        }
    );
}

export default instance